import Img from 'gatsby-image/withIEPolyfill'
import PropTypes from 'prop-types'
import React from 'react'
import Slider from 'react-slick'
import { artDirecting, classes } from '../utils/components'
import '../vendor/react-slick.css'
import Button from './button'
import styles from './hero.module.css'
import TextBlock from './text-block'

const StylesEnum = Object.freeze({
  'full-height': styles.fullHeight,
  normal: styles.normal,
  small: styles.small,
})

/**
 * @param {(string | html)} [title]
 * @param {(string | html)} [description]
 */
const Hero = ({
  className,
  darkMode = false,
  titleFontClass,
  descriptionFontClass,
  buttonClass,
  title,
  description,
  callToAction,
  imageClass,
  imagePosition = '50% 50%',
  image,
  mobileImage,
  narrow = false,
  size = 'normal', // acceptable values - 'full-height', 'normal', 'small'
}) => {
  const carouselSettings = {
    dots: false,
    arrows: false,
    fade: true,
    infinite: true,
    autoplay: true,
    pauseOnHover: false,
    speed: 1000,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  const style = StylesEnum[size] || styles.normal
  return (
    <div className={classes(className, styles.heroWrapper, style)}>
      <Img
        objectPosition={imagePosition}
        fluid={artDirecting(image, mobileImage)}
        className={classes(styles.image, imageClass)}
      />
      <div className={classes(styles.content, 'container')}>
        <TextBlock
          text={title}
          className={classes(styles.title, narrow && styles.titleNarrow)}
          fontClass={classes(titleFontClass || styles.titleFont)}
          colorClass={classes(
            darkMode ? 'text-secondary' : 'text-primary-variant'
          )}
        ></TextBlock>
        {description && description.length ? (
          <Slider className="w-full" {...carouselSettings}>
            {description.map((text, i) => (
              <TextBlock
                key={i}
                className={styles.description}
                fontClass={classes(
                  descriptionFontClass || styles.descriptionFont
                )}
                colorClass={
                  darkMode ? 'text-secondary' : 'text-primary-variant'
                }
                text={text.textNode}
              />
            ))}
          </Slider>
        ) : (
          <TextBlock
            text={description}
            className={styles.description}
            fontClass={classes(descriptionFontClass || styles.descriptionFont)}
            colorClass={darkMode ? 'text-secondary' : 'text-primary-variant'}
          ></TextBlock>
        )}
        {callToAction && callToAction.title ? (
          <Button
            darkMode={darkMode}
            className={classes(buttonClass, styles.callToAction)}
            title={callToAction.title}
            uri={callToAction.link}
          />
        ) : null}
      </div>
    </div>
  )
}

Hero.propType = {
  className: PropTypes.string,
  darkMode: PropTypes.bool,
  titleFontClass: PropTypes.string,
  descriptionFontClass: PropTypes.string,
  buttonClass: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  callToAction: PropTypes.exact({
    title: PropTypes.string,
    link: PropTypes.string,
  }),
  imageClass: PropTypes.string,
  imagePosition: PropTypes.string,
  image: PropTypes.object,
  mobileImage: PropTypes.object,
  narrow: PropTypes.bool,
  size: PropTypes.oneOf(['full-height', 'normal', 'small']),
}

export default Hero
